import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import {fetchPOListForPI, addPiHistory, fetchPIList} from "../../../api/pi"
import {getSASToBlob } from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import SweetAlert from "react-bootstrap-sweetalert";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import Grid from '@mui/material/Grid';
import { formatValueWithCommas } from "../../helper";


const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const InvoicePi = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('PI Update'))

    const [isMount, setIsMount] = useState(true);
    const [poDropdownList, setPODropDownList] = useState([]);
    const [piStatus, setPIStatus] = useState([
       {label: 'YES', value: 'COMPLETE'} ,
       {label: 'NO', value: 'INCOMPLETE'} 
    ]);
    const [piDate, setPIDate] = useState(null)
    const [piNo, setPINo] = useState('')
    const [piAmt, setPIAmt] = useState('')
    const [selectedPo, setSelectedPo] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedPIStatusValue, setSelectedPIStatusValue] = useState(null);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [piList, setPIList] = useState([]);
    const [open, setOpen] = useState(false);
    const [errors, setErrors] = useState({
        po: false,
        piDate: false,
        piNo: false,
        piAmt: false,
        piStatus: false,
    });    

    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    useEffect(()=>{
        if(isMount){
            fetchPOList()
            getPIList()
        }
    },[isMount])
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const getPIList = async()=>{
        try {
            const allPIData = await fetchPIList()
            if(allPIData.statusCode === 200){
                const mappedData = allPIData.data.piList.map((item, index )=> ({
                    id: item.id,
                    Sl_No: index +1,
                    pi_date: item.pi_date,
                    pi_no: item.pi_number,
                    pi_amount: item.pi_amount,
                    pi_status: item.pi_status,
                    po_number: item.procurementErpPODetails.PONUMBER,
                    pi_file_name: item.fileName,
                    pi_file_upload: item.download_link? item.download_link: '--'

                }));
                setPIList(mappedData)

            }
        }
        catch(error){
            console.log('error in fetching PI history', error)
            toast.error('error in fetching PI history')
        }
    }
    const fetchPOList = async() =>{
        setIsMount(false)
        try {
            const response = await fetchPOListForPI()
            if(response.statusCode === 200){
                const res = response.data.poList
                const poDropDown = res.map(item => ({
                    label: item.PONUMBER,
                    value: item.id
                }));
                setPODropDownList(poDropDown)
            }
        }
        catch(error){
            console.log('error in fetching po list', error)
            toast.error('error in fetching po list')
        }
    }
    const handlePoChange = (event, value) => {
        setSelectedPo(value);
        setErrors(prev => ({ ...prev, po: !value }));

      };
      const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
      };
    
      const handleFileUpload = () => {
        if (selectedFile) {
          console.log("Selected File:", selectedFile);
        } else {
          console.log("No file selected");
        }
      };
      const handlePiStatusChange = (event, value) => {
        setSelectedPIStatusValue(value);
        setErrors(prev => ({ ...prev, piStatus: !value }));

      };
    
      const handleDateChange = (date) => {
        setPIDate(date);
        setErrors(prev => ({ ...prev, piDate: !date }));

      };
      const handlePINoChange = (event) => {
        setPINo(event.target.value);
        setErrors(prev => ({ ...prev, piNo: !event.target.value }));

      };
      const handlePIAmtChange = (event) => {
        if(event.target.value >= 0 && event.target.value < 999999999){

        setPIAmt(event.target.value);
        setErrors(prev => ({ ...prev, piAmt: !event.target.value }));
        }
      };
      const handleFormSubmit =async () => {
        let formIsValid = true;

        if (!selectedPo) {
            setErrors(prev => ({ ...prev, po: true }));
            formIsValid = false;
        }

        if (!piDate) {
            setErrors(prev => ({ ...prev, piDate: true }));
            formIsValid = false;
        }

        if (!piNo) {
            setErrors(prev => ({ ...prev, piNo: true }));
            formIsValid = false;
        }

        if (!piAmt) {
            setErrors(prev => ({ ...prev, piAmt: true }));
            formIsValid = false;
        }

        if (!selectedPIStatusValue) {
            setErrors(prev => ({ ...prev, piStatus: true }));
            formIsValid = false;
        }
        if (formIsValid) {

            setSubmitModalOpen(true);
        }

    };

    const submitRequisition = async () => {
        handleOpen()
            const formData = {
                erp_po_id: Number(selectedPo.value),
                pi_date: dayjs(piDate).format('YYYY-MM-DD'),
                pi_number: piNo,
                pi_amount: piAmt,
                pi_status: selectedPIStatusValue.value
            };
        
            if (selectedFile) {
               const response =  await getSASToBlob({uploadType:'PI'})
    
               const fetchOptions = {
                    method: 'PUT',
                    body: selectedFile,
                    headers: {
                        'x-ms-blob-type': 'BlockBlob',
                        'Content-Type': selectedFile.type 
                    },
                }
                if(response.statusCode===200 && response.data.preSignedUrl){
    
                    try {
                        const res = await fetch(response.data.preSignedUrl, fetchOptions);
            
                        if (res.ok) {
                            formData.blobName = response.data.blobName
                            formData.fileName = selectedFile.name
    
                        }
                    } catch (error) {
                        console.error('Error uploading file:', error);
                        toast.error('Error uploading file')
                        return
                    }
                    
                }
            }
            try {
    
                const createPI =  await addPiHistory(formData)
                if(createPI.statusCode === 200){
                    setSubmitModalOpen(false);
                    setIsOpenSweetAlert(true);
                }
            }
            catch(error){
                console.log('error in creating PI',error)
                toast.error('error in creating PI')
            }
            finally{
                handleClose()
                resetFields()
            }
    };

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };
    const resetFields = ()=>{
        setIsMount(true)
        setPIAmt('')
        setPIDate(null)
        setPINo('')
        setSelectedPo(null)
        setSelectedFile(null)
        setSelectedPIStatusValue(null)
        setErrors({
            po: false,
            piDate: false,
            piNo: false,
            piAmt: false,
            piStatus: false,
        });
    }

    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        // {
        //     field: 'po_number',
        //     headerName: 'PO Number',
        //     headerClassName: 'table-header-background',
        //     // width: 160,
        //     editable: false,
        //     resizable: false,
        //     sortable: false,
        //     flex: 1,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        // },
        {
            field: 'pi_date',
            headerName: 'PI Date',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'pi_no',
            headerName: 'PI Number',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap center-aligndata',
            headerAlign: 'center',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'pi_amount',
            headerName: 'PI Amount',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'pi_status',
            headerName: 'PI Status',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            resizable: false,
            maxWidth: 180,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                let status = params.value;
                let chipColor = 'default';
                if (status === 'Pending') {
                  chipColor = 'error'; // Red color for waiting for response
                  status = 'Waiting for response'; // Change status text
    
                } else if (status === 'Approved') {
                  chipColor = 'success'; // Green color for approved
                }     
                return <Chip className="status_badge mt-1 mb-1" label={status} variant="outlined" color={chipColor} />;
              },
          },
        //   {
        //     field: 'file_name',
        //     headerName: 'PI File Name',
        //     headerClassName: 'table-header-background',
        //     sortable: false,
        //     resizable: false,
        //     // width: 160,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //     flex: 1
        // },
        {
            field: 'file_upload',
            headerName: 'File Upload',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                if (params.value === '--') {
                    return '--'; // If pi_file_upload value is '--', render '--'
                } else {
                    return (
                        <div>
                            <a href={params.value} target="_blank" rel="noopener noreferrer" className="download-link">
                                Download
                            </a>
                        </div>
                    );
                }
            },
        },
    ];

    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={open}
                            onClick={handleClose}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center justify-content-between mb-2 gap-2'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>Update PI</p>
                                            <div>
                                                <Autocomplete
                                                    className="invoice_autofield"
                                                    id={`erp-po`}
                                                    sx={{ width: 190 }}
                                                    options={poDropdownList}
                                                    value={selectedPo}
                                                    onChange={handlePoChange}
                                                    getOptionLabel={(option) => option.label}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Select PO" />
                                                    )}
                                                />
                                                {errors.po && <div style={{ color: 'red' }}>PO is required</div>}

                                            </div>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3 p-3'
                                     style={{backgroundColor: '#FAFDFF', border:'1px solid #C3E8FF', borderRadius:'5px'}}>
                                     <Grid container item xs={12} sm={12} spacing={1}>
                                     <Grid item xs={3}>
                                        {/* <div> */}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    id={`pi-date`}
                                                    className='payment_date date_picker_fullwidth'
                                                    label="PI Date"
                                                    value={piDate}
                                                    onChange={handleDateChange}
                                                    sx={{ width: '100%', }}
                                                />
                                            </LocalizationProvider>
                                            {errors.piDate && <div style={{ color: 'red' }}>PI Date is required</div>}
                                        {/* </div> */}
                                       </Grid>
                                       <Grid item xs={3}>
                                        {/* <div> */}
                                            <TextField
                                               className="create_requisition_textfield"
                                                id={`pi-no`}
                                                label="PI No"
                                                variant="outlined"
                                                onChange={handlePINoChange}
                                                type='text'
                                                value={piNo}
                                                sx={{ width: '100%', }}
                                                // sx={{ width: 230 }}
                                            />
                                            {errors.piNo && <div style={{ color: 'red' }}>PI Number is required</div>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={3}>
                                        {/* <div> */}
                                            <TextField
                                               className="create_requisition_textfield"
                                                id={`pi-amt`}
                                                label="PI Amount"
                                                variant="outlined"
                                                value={piAmt}
                                                type='number'
                                                onChange={handlePIAmtChange}
                                                sx={{ width: '100%', }}
                                            />
                                            {errors.piAmt && <div style={{ color: 'red' }}>PI Amount is required</div>}
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={3}>
                                        {/* <div> */}
                                            <Autocomplete
                                                    className="invoice_autofield"
                                                    id={`pi-status`}
                                                    // sx={{ width: 230 }}
                                                    options={piStatus}
                                                    value={selectedPIStatusValue}
                                                    onChange={handlePiStatusChange}
                                                    renderInput={(params) => <TextField {...params} label="PI Status" />}
                                            />
                                            {errors.piStatus && <div style={{ color: 'red' }}>PI Status is required</div>}

                                            
                                        {/* </div> */}
                                        </Grid>
                                    </Grid>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mt-3">
                                    <div className='d-flex align-items-center gap-2'>
                                        <p className="mb-0" style={{fontSize:'16px', fontWeight:'400', color:'#2B2A29'}}>Upload File</p>
                                        <div className="upload-btn-wrapper">
                                            <button className="btn">Upload</button>
                                            <input type="file" name="myfile" onChange={handleFileChange} />
                                            {selectedFile && <p className="mb-0" style={{ color: "#0060AA" }}>{selectedFile.name}</p>}
                                            
                                        </div>
                                    </div>
                                     <div><button className="save_button"  onClick={handleFormSubmit}>Submit</button></div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            <div>
                                <h4 className="mb-0 requisition_text">All Updated PI</h4>
                            </div>
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={piList}
                                    columns={columns}
                                    initialState={{
                                        // pagination: {
                                        //     paginationModel: {
                                        //         pageSize: 5,
                                        //     },
                                        // },
                                    }}
                                    pageSizeOptions={[]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to update this PI?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>PO Number</th>
                                            <th>PI Date</th>

                                            <th>PI Number</th>

                                            <th>PI Amount</th>
                                            <th>PI Status</th>
                                    
                                            
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{selectedPo?.label}</td>
                                                <td>{dayjs(piDate).format('YYYY-MM-DD')}</td>
                                                <td>{piNo}</td>
                                                <td>{piAmt}</td>
                                                <td>{selectedPIStatusValue?.label}</td>
                                                
                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={open} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title='PI created successfully'
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm}

            />
        </React.Fragment>
    );
};

export default InvoicePi;
